import type { LayoutTree, Pane } from "@hq/contracts";
import { createContext, useContext } from "react";
import type { OpenOptions } from "./model";
import type { PaneSpec } from "./paneTypes";

export type WorkspaceApi = {
  tree: LayoutTree;
  setTree: (next: LayoutTree | ((prev: LayoutTree) => LayoutTree)) => void;
  /** Apply a URL selected by the router without creating another history entry. */
  restoreRoute: (spec: PaneSpec) => void;
  /** Navigation: replaces the focused group's unpinned pane. */
  open: (spec: PaneSpec, opts?: OpenOptions) => void;
  /** Notes from lists open as previews; `pinned` for notes you are about to edit. */
  openNote: (noteId: string, opts?: { autoFocus?: boolean; pinned?: boolean }) => void;
  openTask: (taskId: string) => void;
  close: (paneId: string) => void;
  closeOthers: (paneId: string) => void;
  closeGroup: (paneId: string) => void;
  pin: (paneId: string) => void;
  unpin: (paneId: string) => void;
  setTitle: (paneId: string, title: string) => void;
  setParams: (paneId: string, params: Record<string, unknown>) => void;
  focused: Pane | undefined;
};

export const WorkspaceContext = createContext<WorkspaceApi | null>(null);

export function useWorkspace(): WorkspaceApi {
  const api = useContext(WorkspaceContext);
  if (!api) throw new Error("useWorkspace must be used inside <Workspace>");
  return api;
}
